/** @format */
import { useContext } from 'react';

import {
    FeatureFlag,
    FeatureFlagName,
} from '@toucan/common/services/feature-flags/types';

import { FeatureFlagContext } from '@toucan/client/global/feature-flag';

export const useFeatureFlag = <Variant = unknown>(
    flagName: FeatureFlagName
): FeatureFlag<Variant> | undefined => {
    const { featureFlags } = useContext(FeatureFlagContext);

    const featureFlag = featureFlags?.find((flag) => flag.name === flagName);

    if (!featureFlag) {
        return;
    }

    return featureFlag as FeatureFlag<Variant>;
};
